import "client-only"

const environmentPrefixes = ["dev2.", "dev.", "local.", "test."] as const

type EnvironmentPrefix = (typeof environmentPrefixes)[number] | ""

function detectEnvironmentPrefix(): EnvironmentPrefix {
  const hostname = window.location.hostname
  return environmentPrefixes.find((prefix) => hostname.startsWith(prefix)) ?? ""
}

export const environmentPrefixStore = {
  getServerSnapshot: (): EnvironmentPrefix => "",

  getSnapshot: detectEnvironmentPrefix,

  subscribe: (): (() => void) => () => {
    // No-op - window.location.hostname never changes during a browser session,
    // so no subscription is needed.
  },
}
